// React
import React, { Fragment, useState } from 'react'
import { compose } from 'redux'

// Components
import { Breakdown, HostStyles, Total } from './styles'
import P from 'ui/elements/P'
import Spacer from 'ui/blocks/Spacer'
import Div from 'ui/elements/Div'
import { Errors } from './Errors'
import CheckoutButton from './Buttons/Checkout'
import BackToStoreButton from './Buttons/BackToStore'
import Discounts from './Discounts'

// Hooks
import { useTranslation } from 'shared/utils/useTranslation'
import { useCart } from 'shop-components/utils/useCart'
import { useCannotCheckout } from 'shop-components/utils/useCannotCheckout'

// Shared
import withStore from 'shop-components/utils/withStore'
import withTheme from 'shop-components/utils/withTheme'
import registerCustomElement from 'shop-components/utils/registerCustomElement'
import { Format as FormatUtils } from 'back_office/v2/utils/utils'


const Totals = () => {
  const [error, setError] = useState(null)
  const { t } = useTranslation('user')
  const cannotCheckout = useCannotCheckout()
  const { cart, totalPriceAttribute, showPrices, currency } = useCart()

  if (!cart?.lines) return null

  return (
    <Fragment>
      <HostStyles />
      <Div>
        {showPrices && (
          <Fragment>
            <Discounts cart={cart} />
            <Total>
              <P>{t('user.store.subtotal')}</P>
              <P>{FormatUtils.money(cart[totalPriceAttribute], currency)}</P>
            </Total>
            {cart.deposit_in_cents > 0 && (
              <Fragment>
                <Spacer size="xs" />
                <Breakdown>
                  <P>{t('user.store.security_deposit')}</P>
                  <P>{FormatUtils.money(cart.deposit_in_cents, currency)}</P>
                </Breakdown>
              </Fragment>
            )}
            <Spacer />
          </Fragment>
        )}
        <Errors onError={setError} />
        <CheckoutButton disabled={!!error || cannotCheckout} />
        <Spacer />
        <BackToStoreButton />
      </Div>
    </Fragment>
  )
}

const decoratedComponent = compose(withTheme, withStore)(Totals)

registerCustomElement('bq-cart-totals', decoratedComponent)

export default decoratedComponent
